/**
 * Feature flags · controlan qué secciones del producto están visibles para los usuarios.
 *
 * Cómo funciona:
 *   - Cada flag tiene un default declarado aquí.
 *   - Si la variable de entorno `REACT_APP_FEATURE_<NAME>` está definida, sobreescribe el default.
 *     Acepta "true"/"false"/"1"/"0".
 *   - Así puedes ocultar/reactivar cosas sin tocar el código, simplemente cambiando el .env.
 *
 * Filosofía: defaults = "lanzamiento minimalista" (oculta WhatsApp, cupones, programa
 * afiliados B2C, A/B testing, cache stats). Cuando quieras activarlos, basta con
 * poner REACT_APP_FEATURE_COUPONS=true en el .env.
 */

function flag(name, defaultValue) {
  const raw = process.env[`REACT_APP_FEATURE_${name}`];
  if (raw === undefined || raw === null || raw === "") return defaultValue;
  const v = String(raw).toLowerCase().trim();
  if (v === "true" || v === "1" || v === "yes" || v === "on") return true;
  if (v === "false" || v === "0" || v === "no" || v === "off") return false;
  return defaultValue;
}

export const FEATURES = {
  // Apartados ocultos para el lanzamiento inicial (Junio 2026)
  WHATSAPP_BUSINESS: flag("WHATSAPP_BUSINESS", false),
  COUPONS: flag("COUPONS", false),
  AFFILIATES_B2C: flag("AFFILIATES_B2C", false), // botón "refer-a-amigo" en dashboards públicos
  // SuperAdmin · uso interno tuyo - los dejamos visibles por defecto solo para superadmin
  SUPERADMIN_AB_TESTING: flag("SUPERADMIN_AB_TESTING", true),
  SUPERADMIN_CACHE_STATS: flag("SUPERADMIN_CACHE_STATS", true),
  SUPERADMIN_AI_INSIGHTS: flag("SUPERADMIN_AI_INSIGHTS", true),
};

export const isFeatureEnabled = (name) => Boolean(FEATURES[name]);
